import { getData } from '@/packages/namba-metrics/helpers'

export function useSendSessionTime() {
    const sessionStartTime = new Date()

    function sendCloseData() {
        const data = getData({
            name: 'sessionTime',
            time: new Date().getTime() - sessionStartTime.getTime(),
        })

        const blob = new Blob([JSON.stringify(data)], {
            type: 'application/json',
        })
        navigator.sendBeacon(
            `${process.env.VUE_APP_NAMBA_METRICS_API_DOMAIN}/api/event`,
            blob
        )
        window.removeEventListener('pagehide', sendCloseData)
        window.removeEventListener('unload', sendCloseData)
        document.removeEventListener('visibilitychange', onVisibilityChange)
    }

    function onVisibilityChange() {
        if (document.visibilityState === 'hidden') {
            sendCloseData()
        }
    }

    window.addEventListener('pagehide', sendCloseData)

    window.addEventListener('unload', sendCloseData)

    document.addEventListener('visibilitychange', onVisibilityChange)
}
